import './Radio.scss'
import classnames from 'classnames'
import InputWrapper from './InputWrapper'
import React, { Component, PropTypes } from 'react'

export const RadioButton = (props, { radioGroup }) => {
  return (
    <label className={classnames('RadioButton', props.className)}>
      <input
        type='radio'
        value={props.value}
        name={radioGroup.id}
        checked={props.value === radioGroup.value}
        onChange={() => radioGroup.onChange(props.value)}
      />
      <span className='RadioButton_toggle' />
      {props.children}
    </label>
  )
}

RadioButton.displayName = 'RadioButton'

RadioButton.contextTypes = {
  radioGroup: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func
  })
}

export class RadioGroup extends Component {
  getChildContext () {
    return {
      radioGroup: {
        id: this.props.any,
        value: this.props.value,
        onChange: this.props.onChange
      }
    }
  }

  render () {
    return (
      <InputWrapper {...this.props} className={classnames('RadioGroup', this.props.className)}>
        {this.props.children}
      </InputWrapper>
    )
  }
}

RadioGroup.displayName = 'RadioGroup'

RadioGroup.childContextTypes = {
  radioGroup: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func
  })
}



// WEBPACK FOOTER //
// ./src/lib/form/Radio.js